import { Injectable } from '@angular/core';
import { firstValueFrom, from, Observable } from 'rxjs';
import { ConfectionaryProductModel, DateRange, PagedList, ProductDiscardInfoModel } from '../interface';
import { CashboxResourceService, ConfectioneryResourceService, PriceShortModel, ProductResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxProductService {

  constructor(
    private cashboxResource: CashboxResourceService,
    private productLegacy: ProductResourceService,
    private confectionery: ConfectioneryResourceService,
  ) { }

  getProductDiscards(params: {date?: DateRange, storeId?: number, userId?: number, productInfoId?: number, groupByDate?: boolean}): Observable<ProductDiscardInfoModel[]> {
    return this.productLegacy.discards(params.date?.from, params.date?.to, params.groupByDate, params.productInfoId, params.storeId, params.userId) as unknown as Observable<ProductDiscardInfoModel[]>;
  }

  getPrices(params?: {
    productInfoIds?: number[],
    date?: string,
    storeId?: number,
  }): Promise<PriceShortModel[]> {
    return firstValueFrom(this.productLegacy.prices(params?.date, params?.productInfoIds, params?.storeId));
  }

  getPriceById(id: number): Promise<PriceShortModel> {
    return firstValueFrom(this.productLegacy.priceById(id));
  }

  getDeliveryPrices(params?: {
    date?: string,
    storeId?: number,
  }): Promise<PriceShortModel[]> {
    return firstValueFrom(this.productLegacy.deliveryPrices(params?.date, params?.storeId));
  }

  getCfProductList(params?: {
    storeId?: number;
    date?: DateRange;
    query?: string;
    userId?: number;
    page?: number;
    limit?: number;
  }): Observable<PagedList<ConfectionaryProductModel>> {
    return this.confectionery.getProducts(params?.date?.from, params?.date?.to, params?.limit, params?.page, params?.query, params?.storeId, params?.userId) as unknown as Observable<PagedList<ConfectionaryProductModel>>;
  }

  reserveProduct(req: { productInfoId: number }): Observable<{ id: number }> {
    return from(firstValueFrom(this.productLegacy.reserve(req as any)).then(r => r as any));
  }

  updateProductBarcodeByProductId(productId: number, barcode: string) {
    return firstValueFrom(this.cashboxResource.updateProductBarcodeByProductId(barcode, productId));
  }

  deleteProductBarcode(productId: number, barcode: string) {
    return firstValueFrom(this.cashboxResource.deleteProductBarcode(barcode, productId));
  }
}
